import { useNavigate } from "react-router-dom";
import ProductForm from "../../components/admin/ProductForm";

export default function ProductCreate() {
  const nav = useNavigate();

  return (
    <div>
      <h1 style={{ marginTop: 0 }}>Create Product</h1>
      <div
        style={{
          border: "1px solid #eee",
          borderRadius: 12,
          padding: 12,
          background: "#fff",
        }}
      >
        <ProductForm
          mode="create"
          onSaved={(saved) => {
            if (saved?._id) {
              nav(`/products/${saved._id}`, { replace: true });
            }
          }}
        />
      </div>
    </div>
  );
}
